
// import { ClientUtil } from "./../javascripts/utils/clientUtil"
export class ClientUtil {
  /**
   * http通信を行う
   * 更新処理を行う場合csrfトークンを埋め込むこと
   * @param {string} url 通信先URL
   * @param {string} method "GET" | "POST"
   * @param {(response?: any) => void} onDone 通信完了時処理
   */
  public static fileUpload(
    url: string,
    file: File,
    onDone: (response?: string) => void,
    onError: ((status?: string, response?: string) => void) | null = null) {

    // ファイルをフォームに入れる
    // const formData = new FormData()
    // files.forEach((file) => {
    //   formData.append(file.name, file)
    // })
    const reader = new FileReader()
    reader.onloadend = () => {
      const formData = new FormData()
      const imgBlob = new Blob([reader.result!], { type: file.type })
      formData.append("thumbnail", imgBlob, file.name)

      const xhr = new XMLHttpRequest()
      xhr.open("POST", url, true)
      // xhr.setRequestHeader("X-XSRF-Token", (document.getElementById("csrfToken") as HTMLInputElement).value)
      // xhr.setRequestHeader("Pragma", "no-cache")
      // xhr.setRequestHeader("Cache-Control", "no-cache")
      // xhr.setRequestHeader("If-Modified-Since", "Thu, 01 Jun 1970 00:00:00 GMT")
      xhr.onreadystatechange = () => {
        switch (xhr.readyState) {
          case 0: // UNSENT. open() not called
            console.log("uninitialized!")
            break
          case 1: // OPEND. send() not called
            console.log("loading...")
            break
          case 2: // HEADERS_RECEIVED. send() called & headers recieved
            console.log("loaded.")
            break
          case 3: // LOADING. downloading ...
            // console.log("interactive... ")
            break
          case 4: // DONE. completed
            if (xhr.status === 200 || xhr.status === 304) {
              onDone(xhr.response)
            } else {
              console.log("Failed. HttpStatus: " + xhr.statusText)
              if (onError) {
                onError(xhr.statusText, xhr.responseText)
              }
            }
            break
          default:
            console.log("error nop default")
        }
      }
      // if (isBinary) {
      //   xhr.responseType = "blob"
      // }
      // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      // node Express でマルチパートは厳しい
      // xhr.setRequestHeader("Content-Type", "multipart/form-data; boundary=blob")
      xhr.send(formData)
    }
    reader.readAsArrayBuffer(file)


  }

  /** Domを削除する */
  public static removeDom(dom: HTMLElement | null) {
    if (dom) {
      const parent = dom.parentNode
      if (parent) {
        parent.removeChild(dom)
      }
    }

  }


  /**
   * データをファイル化してダウンロードする
   * @param data 文字列
   * @param isBom データが文字列の時のみ有効
   */
  public static localDownload(data: any, fileName: string = "file.csv", isBom = true) {

    let blob: Blob

    if (typeof data === "string") {
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      if (isBom) {
        blob = new Blob([bom, data], { type: "application/x-msdownload" })
      } else {
        blob = new Blob([data], { type: "application/x-msdownload" })
      }

    } else {
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const buffer = new Uint8Array(data.length)
      for (let i = 0; i < data.length; i++) {
        buffer[i] = data.charCodeAt(i)
      }
      blob = new Blob([buffer.buffer], { type: "application/x-msdownload" })

    }

    this.localDownloadBlob(blob, fileName)

  }

  /**
   * ブロブデータをダウンロードする
   * @param data 文字列
   * @param fileName ファイル名
   */
  public static localDownloadBlob(blob: Blob, fileName: string = "file.csv") {

    const link = document.createElement("a")
    link.setAttribute("download", fileName)
    link.href = URL.createObjectURL(blob)
    // link.click();  // IE, Chrome

    // IE, Edge, Chrome, FireFox
    if (window.navigator.msSaveBlob) {
      // window.navigator.msSaveBlob(blob, fileName)
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      const evt = document.createEvent("MouseEvents")
      evt.initEvent("click", false, true)
      link.dispatchEvent(evt)
    }
  }

  public static sanitaize() {
    return {
      encode: (src: string) => {
        return src.replace(/&/g, "&amp;").
          replace(/</g, "&lt;").
          replace(/>/g, "&gt;").
          replace(/"/g, "&quot;").
          replace(/'/g, "&#39;")
      },

      decode: (src: string) => {
        return src.replace(/&lt;/g, "<").
          replace(/&gt;/g, ">").
          replace(/&quot;/g, '"').
          replace(/&#39;/g, "'").
          replace(/&amp;/g, "&")
      },
    }
  }

  public static loadStart() {
    document.getElementById("loading")!.classList.remove("hidden")
  }
  public static loadStop() {
    document.getElementById("loading")!.classList.add("hidden")
  }

}
